import styled from "styled-components";

export const StyledLinkButton = styled.div`
  position: absolute !important;
  z-index: 5;
  right: 0;
  top: 0;
`;
